export default __webpack_public_path__ + "static/media/gw4.74d09e9d.webp";